import { animations } from './moa.animations';

/**
 * Animation object for mod
 */
export const moaAnimations: any = {
	enter (frameId: string): void {
		const frameAnimations = animations[frameId];
		if (frameAnimations) {
			const { enter } = frameAnimations();
			if (enter) { enter(); }
		}
	},
	leave (frameId: string): void {
		const frameAnimations = animations[frameId];
		if (frameAnimations) {
			const { leave } = frameAnimations();
			if (leave) { leave(); }
		}
	}
}